import angular from 'angular';
import AppStorageSlot from './appStorageSlot';

class AppStorage {
  constructor($log, $window, appConfiguration, appUtils) {
    'ngInject';

    this.appConfiguration = appConfiguration;
    this.appUtils = appUtils;

    let storage;
    if ($window.localStorage) {
      storage = $window.localStorage;
    } else if ($window.sessionStorage) {
      $log.warn('The device doesn\'t support localStorage; using sessionStorage');
      storage = $window.sessionStorage;
    } else {
      $log.warn('The device doesn\'t support neither localStorage nor sessionStorage');
      storage = {};
    }

    this.storage = storage;
    this.storageKey = this.getStorageKey();

    this._slots = {};
    this._slotsOriginals = {};
    this._store = null;

    this._initializeStore();
  }
  getStorageKey() {
    return this.appConfiguration.storageKeys.store;
  }
  register(name, target) {
    if (this._slots[name]) {
      throw new Error(`There's already a slot registered with the name: ${name}`);
    }

    this._slots[name] = target;
    this._slotsOriginals[name] = angular.copy(target);
    this._loadSlot(name);

    return new AppStorageSlot(this, name, Object.keys(target));
  }
  target(name) {
    return this._getSlot(name);
  }
  save(name) {
    this._saveSlot(name);
  }
  reset(name) {
    this._resetSlot(name);
  }
  delete() {
    delete this.storage[this.storageKey];
    this._store = {};
  }
  _initializeStore() {
    this._store = this.storage[this.storageKey] ?
      angular.fromJson(this.storage[this.storageKey]) :
      null;

    if (!this._store) {
      this.storage[this.storageKey] = '';
      this._store = {};
    }
  }
  _loadSlot(name) {
    // Get the reference to the target object
    const target = this._getSlot(name);
    // Get the data stored
    const stored = this._getSlotFromStore(name);
    // If there's stored data, copy it to the slot target object
    if (stored) {
      this.appUtils.copyObjectValues(stored, target);
    } else if (!stored) {
      // If there's no stored data, save the value that is currently on the target object
      this._saveSlot(name);
    }
  }
  _updateStorage() {
    this.storage[this.storageKey] = angular.toJson(this._store);
  }
  _getSlot(name) {
    return this._slots[name];
  }
  _getSlotFromStore(name) {
    return this._store[name] || null;
  }
  _saveSlot(name) {
    this._copySlotTargetValues(name);
    this._updateStorage();
  }
  _resetSlot(name) {
    this.appUtils.copyObjectValues(this._slotsOriginals[name], this._getSlot(name));
    this._saveSlot(name);
  }
  _copySlotTargetValues(name) {
    const stored = this._getSlotFromStore(name);
    const target = this._getSlot(name);
    if (stored) {
      this.appUtils.copyObjectValues(target, stored);
    } else {
      this._store[name] = angular.copy(target);
    }
  }
}

export default AppStorage;
